import script from "./MapComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MapComponent.vue?vue&type=script&setup=true&lang=js"

import "./MapComponent.vue?vue&type=style&index=0&id=074d0998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074d0998"]])

export default __exports__